import * as React from 'react';
import { Box, TextField, Button, Paper, Typography } from '@mui/material';
import { InputAdornment, IconButton } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

interface ChangePasswordProps {
  username: string;
  onSubmit: (payoad: IChangePasswordPayload) => void;
}

export default function ChangePassword(props: ChangePasswordProps) {

  const [oldPassword, setOldPassword] = React.useState('');
  const [newPassword, setNewPassword] = React.useState('');

  const [showOldPassword, setShowOldPassword] = React.useState(false);
  const [showNewPassword, setShowNewPassword] = React.useState(false);

  const handleSubmit = () => {
    props.onSubmit({ username: props.username, oldPassword, newPassword });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '400px', gap: 4, mb: 2 }}>    

      <Typography component="h2" variant="h5" >
        Password Change
      </Typography>

      {/* Username (readonly) */}
      <TextField 
        label='Username'
        type='text'
        disabled={true}
        value={props.username}
        sx={{ width: '100%'}}/>

      {/* Old password */}
      <TextField 
        label='Old Password'
        type={showOldPassword ? 'text' : 'password'}
        value={oldPassword}
        sx={{ width: '100%'}}
        onChange={(e) => setOldPassword(e.target.value)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowOldPassword(!showOldPassword)}
                onMouseDown={(e) => e.preventDefault()}>
                {showOldPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      {/* New password */}
      <TextField 
        label='New Password'
        type={showNewPassword ? 'text' : 'password'}
        value={newPassword}
        sx={{ width: '100%'}}
        onChange={(e) => setNewPassword(e.target.value)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowNewPassword(!showNewPassword)}
                onMouseDown={(e) => e.preventDefault()}>
                {showNewPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      {/* Submit button */}
      <Button 
        variant="contained" color="primary" 
        sx={{ mt: 0 }}
        disabled={oldPassword === '' || newPassword === ''}
        onClick={handleSubmit}>
        Save
      </Button>

    </Box>

  );
}